import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box} from 'views/components';

import CaregiverDetails from './caregiver_details/CaregiverDetails';
import CaregiverTitle from './title/CaregiverTitle';
import CaregiverDescription from './description/CaregiverDescription';
import CaregiverPhoto from './photo/CaregiverPhoto';
import CaregiverAnnouncement from './announcement/CaregiverAnnouncement';

const CaregiverHeader = (props) => {
  const caregiverRn = props.caregiverRn;
  const caregiverData = props.caregiverData;
  const caregiverBioQuestions = props.caregiverBioQuestions;
  const caregiverBackend = props.caregiverBackend;
  const refresh = props.refresh;
  const setRefresh = props.setRefresh;
  return (
    <Stack gap={1}>
      <CaregiverTitle
        caregiverRn={caregiverRn}
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
      />
      <CaregiverDetails
        caregiverData={caregiverData}
        caregiverBioQuestions={caregiverBioQuestions}
        caregiverBackend={caregiverBackend}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Stack direction={{md: 'row', xs: 'column'}}>
        <Box
          sx={{
            width: {md: '15%', xs: '100%'},
          }}
        >
          <CaregiverPhoto
            caregiverRn={caregiverRn}
            caregiverData={caregiverData}
            caregiverBioQuestions={caregiverBioQuestions}
            caregiverBackend={caregiverBackend}
          />
        </Box>
        <Box
          sx={{
            width: {md: '85%', xs: '100%'},
          }}
        >
          <CaregiverDescription
            caregiverRn={caregiverRn}
            caregiverData={caregiverData}
            caregiverBackend={caregiverBackend}
          />
        </Box>
      </Stack>
      <CaregiverAnnouncement
        caregiverRn={caregiverRn}
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
      />
    </Stack>
  );
};
CaregiverHeader.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(CaregiverHeader);
